/* eslint-disable import/prefer-default-export */ export function numberInRange(param) {
    var props = param.props, propName = param.propName, componentName = param.componentName, isRequired = param.isRequired, rangeStart = param.rangeStart, rangeEnd = param.rangeEnd;
    if (typeof rangeStart !== "number" || typeof rangeEnd !== "number" || rangeStart >= rangeEnd) {
        return new Error("Invalid rangeStart or rangeEnd is passed to ".concat(componentName, " ").concat(propName, " prop validator"));
    }
    var value = props && props[propName];
    if (isRequired && !value && value !== 0) {
        return new Error("Invalid prop ".concat(propName, " is supplied to ").concat(componentName, ". ").concat(propName, " is required"));
    }
    if (value && typeof value !== "number") {
        return new Error("Invalid prop ".concat(propName, " is supplied to ").concat(componentName, ". ").concat(propName, " should be a number"));
    }
    if (value < rangeStart || value > rangeEnd) {
        return new Error("Invalid prop ".concat(propName, " is supplied to ").concat(componentName, ". ").concat(propName, " is not in ").concat(rangeStart, " to ").concat(rangeEnd, " range"));
    }
    return null;
}
